import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { sp } from '@/theme/mui';
import { BaseField, FieldProps } from '@/components/atoms/BaseField/BaseField';

export const Date = ({
  id,
  label,
  description,
  tooltip,
  isRequired,
  isHideTitle,
  value,
  onChange,
  validate = () => true,
}: DateProps) => {
  const [isError, setIsError] = useState(false);

  useEffect(() => {
    setIsError(!validate(value) && !!value);
  }, [value, validate]);

  return (
    <BaseField
      id={id}
      label={label}
      description={description}
      tooltip={tooltip}
      isRequired={isRequired}
      isHideTitle={isHideTitle}
    >
      <Box
        component='input'
        type='date'
        value={value?.split('T')?.[0]}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          onChange(e.target.value ? e.target.value + 'T00:00:00.000Z' : '')
        }
        sx={{
          all: 'unset',
          display: 'block',
          width: '100%',
          boxSizing: 'border-box',
          typography: 'bodyMediumWeight',
          color: '#404042',
          background: '#ffffff',
          p: sp[12],
          borderRadius: '8px',
          border: '1px solid #b2b2b2',
          minHeight: '50px',
          maxHeight: '50px',
          ...(isError && {
            border: '1px solid #e7294b',
            background: '#f2ede3',
            '&:focus-within': { border: '1px solid #e7294b' },
          }),
        }}
      />
    </BaseField>
  );
};

interface DateProps extends FieldProps<string> {
  value: string;
  onChange: (value: string) => void;
}

Date.displayName = 'Date';

export default Date;
